module.exports = __webpack_public_path__ + "static/media/dks319.639e4865.png";